<template>
    <transition name="pop" @leave="leave">
        <div class="pop-mask" v-if="isShow">
            <div class="pop-wrap" :class="cls">
                <span class="pop-title" v-if="title">{{ title }}</span>
                <div class="pop-inner">
                    <div class="pop-msg">
                        {{msg}}
                    </div>
                </div>
                <div class="pop-btns" v-if=" btns.length > 0">
                    <a href="javascript:void 0" class="pop-btn pop-btn1" v-if="btns[1]" v-tap="{methods:cancel}">{{ btns[1] }}</a>
                    <a href="javascript:void 0" class="pop-btn" :class="{'pop-btn2':!btns[1]}" v-tap="{methods:confirm}">{{ btns[0] }}</a>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: "Pop",
        data() {
            return {
                isShow: false,
                msg: '',
                cls: '',
                title: '',
                btns: ['确定'],
            }
        },
        callbacks: [],

        methods: {
            closeHandle() {
                this.$options.callbacks = [];
                this.isShow = false;
            },
            open(msg, options = {}) {
                let {cls, ok, cancel, btns, title} = options;
                let callbacks = [];
                typeof ok == 'function' && (callbacks[0] = ok);
                typeof cancel == 'function' && (callbacks[1] = cancel);
                typeof options == 'function' && (callbacks[0] = options);
                if (cls) this.cls = cls;
                if (btns instanceof Array) this.btns = btns;
                if (callbacks.length) this.$options.callbacks = callbacks;
                this.msg = msg;
                this.title = title;
                this.isShow = true;
            },
            confirm() {
                let ok = this.$options.callbacks[0];
                if (!ok || ok.call(this) !== false) this.closeHandle();
            },
            cancel() {
                let cancel = this.$options.callbacks[1];
                if (cancel) cancel.call(this);
                this.closeHandle();
            },
            leave(el, done) {
                setTimeout(done, 200)
            }
        }

    }
</script>
<style lang="scss" rel="stylesheet/scss">

    @import "./src/scss/base/mixins.scss";

    .pop-mask{
        background-color:rgba(0, 0, 0, 0.4);
        align-items:center;
        position:fixed;
        left:0;
        top:0;
        bottom:0;
        right:0;
        width:100%;
        height:100%;
        z-index:50;
        display:flex;
    }

    .pop-wrap{
        background-color:white;
        border-radius:px2(10);
        -webkit-border-radius:px2(10);
        margin:0 px2(40px);
        position:relative;
        width:100%;
        box-sizing:border-box;
        -webkit-box-sizing:border-box;
        transition:all linear .2s;
    }

    .pop-title{
        font-size:px2(32px);
        color:#313131;
        margin:px2(12px);
        text-align:center;
        display:block;
        line-height:1.5;
        font-weight:700;
    }

    .pop-inner{
        width:100%;
        padding:px2(50px) px2(30px) 0;
        box-sizing:border-box;
        .pop-msg{
            font-size:px2(32);
            text-align:center;
            line-height:px2(40);
        }
    }

    .pop-btns{
        display:flex;
        display:-webkit-flex;
        margin:px2(40px) px2(60);
    }

    .pop-btn{
        flex:1;
        -webkit-flex:1;
        height:px2(68px);
        line-height:px2(68px);
        background-color:#ff5809;
        border:px2(1px) solid #ff5809;
        border-radius:px2(12);
        -webkit-border-radius:px2(12px);
        text-align:center;
        font-size:px2(28px);
        color:white;
        box-shadow:0 px2(4) px2(8) px2(4) rgba(233, 185, 91, 0.16);
        -webkit-box-shadow:0 px2(4) px2(8) px2(4) rgba(233, 185, 91, 0.16);
    }

    .pop-btn:after{
        border:0;
    }

    .pop-btn1{
        color:#ff5809;
        background:#fff;
        margin-right:px2(30px);
    }

    .pop-btn2{
        width:px2(360px);
        margin:0 auto;
        flex:none;
        -webkit-flex:none;
    }

    .pop-enter .pop-wrap, .pop-leave-to .pop-wrap{
        opacity:.2;
        transform:scale(.2);
    }

    .pop-enter-active, .pop-enter-active{
        .pop-wrap{
            transition:all linear .2s;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pop/Pop.vue